/**
 * Aviso único: na PRIMEIRA vez que o usuário põe um livro na estante,
 * explicar de onde vem a previsão de leitura que ele vai ver na aba Progresso
 * e no sheet de foco — o ritmo medido nas sessões de Modo Foco.
 *
 * Montado UMA vez no `App`, e não dentro de quem adiciona, porque as
 * superfícies de adição (o `AddToShelfSheet`, o caminho por lista da
 * BookDetail) desmontam logo depois de salvar — um modal filho delas morreria
 * junto com o pai antes de aparecer. O gatilho chega por evento de `window`.
 */
import { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";
import { Button, Modal } from "../../../components/ui";
import { useAuth } from "../../../hooks/useAuth";
import { FIRST_SHELF_NOTICE_EVENT, markFirstShelfNoticeSeen } from "../utils/firstShelfNotice";

export function FirstShelfAddNotice() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handle = () => setOpen(true);
    window.addEventListener(FIRST_SHELF_NOTICE_EVENT, handle);
    return () => window.removeEventListener(FIRST_SHELF_NOTICE_EVENT, handle);
  }, []);

  // Marca ao dispensar, não ao abrir: se o usuário fechar o app antes de ler,
  // o aviso ainda tem uma segunda chance. Um toque em qualquer saída (botão,
  // backdrop, Escape) passa por aqui.
  const dismiss = () => {
    if (user?.uid) markFirstShelfNoticeSeen(user.uid);
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={dismiss} title="Livro na estante!" size="sm" priority="above">
      <div className="flex flex-col gap-4 px-5 pb-5 pt-3">
        <div className="flex items-start gap-3 rounded-card border border-line bg-surface p-3.5">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[11px] bg-accent-soft text-accent-strong">
            <Hourglass className="h-[18px] w-[18px]" strokeWidth={2} aria-hidden />
          </span>
          <p className="font-body text-[12.5px] leading-[1.5] text-ink">
            Toda sessão de <b className="font-semibold">Modo Foco</b> que você
            fechar registrando as páginas lidas me ensina o seu ritmo.
          </p>
        </div>

        <p className="font-body text-[12.5px] leading-[1.5] text-soft">
          Com esse ritmo eu calculo quanto tempo falta pra você terminar cada
          livro — e a conta fica mais certeira a cada sessão. Sem sessão
          nenhuma, não tenho como adivinhar: é o seu tempo de leitura que dá a
          medida.
        </p>

        <Button variant="primary" size="md" className="w-full" onClick={dismiss}>
          Entendi
        </Button>
      </div>
    </Modal>
  );
}
